












































































































import Vue from 'vue';
import Overlay from '../../layout/Overlay.vue';
import TextInput from '../../myprofile/inputs/TextInput.vue';
import CustomButton from '../../layout/buttons/CustomButton.vue';

export default Vue.extend({
  components: { CustomButton, Overlay, TextInput },
  props: {
    merchandiseOverlay: {
      required: true,
      type: Object,
    },
  },
  methods: {
    updateBusinessCard(): void {
      this.$emit(`update:business-card`);
    },
  },
});
